// Türkçe sayfa adresi → İngilizce sayfa adresi (başına /en eklenir).
// Sitedeki TEK kaynak: App.js'teki /en rotaları, dil değiştirme düğmeleri ve
// site içi bağlantılar buradan üretilir. Yeni bir sayfa eklerken buraya da ekleyin.
// Alt adresler önek olarak çalışır: /haberler/abc → /en/news/abc
// Aynı İngilizce adrese giden birden fazla Türkçe adres varsa, İLK yazılan
// Türkçeye geri dönüşte kullanılır.

export const EN_SLUGS = {
  // Genel
  '/arama':                                       '/search',
  '/hakkimizda':                                  '/about',
  '/iletisim':                                    '/contact',
  '/haberler':                                    '/news',
  '/etkinlikler':                                 '/events',
  '/yayinlar':                                    '/publications',
  '/duyurular':                                   '/announcements',
  '/galeri':                                      '/gallery',
  '/albums':                                      '/albums',
  '/videogaleri':                                 '/video-gallery',
  '/engelsiz-yasam':                              '/barrier-free',
  '/sayfa':                                       '/page',
  '/akademik-faaliyet':                           '/academic-activity',
  '/birim-faaliyetleri':                          '/unit-activities',
  '/sosyal-sorumluluk-projeleri':                 '/social-responsibility-projects',
  '/staj':                                        '/internship',

  // Kurumsal
  '/kurumsal/tarihce':                            '/institutional/history',
  '/kurumsal/misyon-vizyon':                      '/institutional/mission-vision',
  '/kurumsal/fedek':                              '/institutional/fedek',
  '/kurumsal/stratejik-plan':                     '/institutional/strategic-plan',
  '/kurumsal/eski-dekanlar':                      '/institutional/former-deans',

  // Yönetim
  '/yonetim/dekan':                               '/administration/dean',
  '/yonetim/dekan-yardimcilari':                  '/administration/vice-deans',
  '/yonetim/fakulte-kurulu':                      '/administration/faculty-board',
  '/yonetim/yonetim-kurulu':                      '/administration/executive-board',
  '/yonetim/fakulte-sekreteri':                   '/administration/faculty-secretary',
  '/yonetim/fakulte-sekreterleri':                '/administration/faculty-secretaries',
  '/yonetim/yonetim-semasi':                      '/administration/organization-chart',

  // Kurul ve komisyonlar
  '/kurul-komisyonlar/birim-danisma-kurulu':      '/boards-commissions/unit-advisory-board',
  '/kurul-komisyonlar/kalite-strateji':           '/boards-commissions/quality-strategy',
  '/kurul-komisyonlar/akademik-birim-kalite':     '/boards-commissions/academic-unit-quality',
  '/kurul-komisyonlar/burs-komisyonu':            '/boards-commissions/scholarship',
  '/kurul-komisyonlar/tanitim-toren':             '/boards-commissions/promotion-ceremony',
  '/kurul-komisyonlar/yayin':                     '/boards-commissions/publication',
  '/kurul-komisyonlar/program-disi-ogrenme':      '/boards-commissions/non-formal-learning',

  // Kararlar (/:year alt adresleri önekle çalışır)
  '/kararlar/fakulte-kurulu':                     '/decisions/faculty-board',
  '/kararlar/fakulte-yonetim':                    '/decisions/executive-board',

  // Personel
  '/fakulte-personeli/ogretim-uyeleri':           '/faculty-staff/faculty-members',
  '/fakulte-personeli/ogretim-gorevlileri':       '/faculty-staff/lecturers',
  '/fakulte-personeli/arastirma-gorevlileri':     '/faculty-staff/research-assistants',
  '/fakulte-personeli/idari-personel':            '/faculty-staff/administrative-staff',
  '/fakulte-personeli/emekli-ogretim-elemanlari': '/faculty-staff/retired-faculty',
  '/personel/akademisyen':                        '/staff/academic',
  '/personel/ogretim-gorevlisi':                  '/staff/lecturers',
  '/personel/idari-personel':                     '/staff/administrative',
  '/personel/arastirma-gorevlisi':                '/staff/research-assistants',
  '/personel/emekli-personel':                    '/staff/retired',

  // Belgeler
  '/belgeler/akademik-idari-personel':            '/documents/academic-administrative-staff',
  '/belgeler/akademik-personel':                  '/documents/academic-administrative-staff',
  '/belgeler/ogrenci':                            '/documents/students',
  '/belgeler/ogrenciler':                         '/documents/students',
  '/belgeler/kanun-yonetmelikler':                '/documents/laws-regulations',
  '/belgeler/gerekli-belge-formlar':              '/documents/required-forms',

  // Araştırma
  '/arastirma/laboratuvarlar':                    '/research/laboratories',
  '/arastirma/kitaplar-editorlukler':             '/research/books-editorships',
  '/arastirma/kitaplar-dergiler':                 '/research/books-editorships',
  '/arastirma/dergiler':                          '/research/journals',
  '/arastirma/muzeler':                           '/research/museums',
  '/arastirma/devam-eden-projelerimiz/dis-destekli': '/research/ongoing-projects/externally-funded',
  '/arastirma/devam-eden-projelerimiz/bap-destekli': '/research/ongoing-projects/bap-funded',
  '/arastirma/devam-eden-projelerimiz':           '/research/ongoing-projects',

  // Bölümler
  '/bolumler/biyoloji/ogretim-uyeleri':           '/departments/biology/faculty-members',
  '/bolumler/biyoloji':                           '/departments/biology',
  '/bolumler/matematik':                          '/departments/mathematics',
  '/bolumler/istatistik':                         '/departments/statistics',
  '/bolumler/aktuerya-bilimleri':                 '/departments/actuarial-sciences',
  '/bolumler/kimya-bolumu-sanal-tur':             '/departments/chemistry-virtual-tour',

  // Mezunlar
  '/mezunlar/liste':                              '/alumni/list',
  '/mezunlar/basari-hikayeleri':                  '/alumni/success-stories',
  '/mezunlar/iletisim':                           '/alumni/contact',
  '/mezunlar':                                    '/alumni',
  '/alumni':                                      '/alumni',

  // Öğrenci ve programlar
  '/ogrenci-topluluklari':                        '/student-clubs',
  '/ogrenci-toplulukları-old':                    '/student-clubs-old',
  '/ogrenci/uluslararasi-ogrenciler':             '/student/international-students',
  '/programlar/lisans':                           '/programs/undergraduate',
  '/programlar/erasmus/ogrenci-deneyimleri':      '/programs/erasmus/student-experiences',
  '/programlar/erasmus':                          '/programs/erasmus',
  '/programlar/yandal':                           '/programs/minor',
  '/programlar/cift-anadal':                      '/programs/double-major',
  '/programlar/yuksek-lisans':                    '/programs/masters',
  '/programlar/doktora':                          '/programs/doctorate',
  '/yuksek-lisans':                               '/graduate-programs',
  '/doktora':                                     '/doctoral-programs',
};
